<template>
  <VCard flat>
    <VForm
      v-model="isFormValid"
      @submit.prevent="editAgent"
    >
      <VCardText>
        <VTextField
          v-model="currentAgent.number"
          :error-messages="errorMessages.number"
          :label="$nt('number')"
          :rules="[$rules.isRequired]"
        />
        <VTextField
          v-model="currentAgent.first_name"
          :error-messages="errorMessages.first_name"
          :label="$nt('firstName')"
          :rules="[$rules.isRequired]"
        />
        <VTextField
          v-model="currentAgent.last_name"
          :error-messages="errorMessages.last_name"
          :label="$nt('lastName')"
          :rules="[$rules.isRequired]"
        />
        <SelectCity
          :value="{zip: currentAgent.zip, city: currentAgent.city }"
          :rules="[$rules.isRequired]"
          :error-messages="errorMessages.city || errorMessages.zip"
          @input="({zip, name}) => Object.assign(currentAgent, {zip, city: name})"
        />
      </VCardText>
      <VCardActions>
        <VSpacer />

        <VBtn
          type="submit"
          color="primary"
          :loading="isLoading"
          :disabled="!isFormValid || isLoading"
        >
          {{ $nt('editAgent') }}
        </VBtn>
      </VCardActions>
    </VForm>
  </VCard>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SelectCity from '@/components/global-components/inputs/SelectCity'

export default {
  name: 'AgentEdit',
  components: { SelectCity },
  props: ['agentId'],
  data () {
    return {
      isFormValid: false,
      errorMessages: {},
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('agent', ['currentAgent'])
  },
  methods: {
    ...mapActions('agent', ['saveAgent']),
    async editAgent () {
      if (!this.isFormValid) return

      this.isLoading = true
      try {
        await this.$notification(this.saveAgent({ agent: this.currentAgent }))
      } catch (e) {
        this.errorMessages = e
      }
      this.isLoading = false
    }
  },
  watch: {
    currentAgent: {
      deep: true,
      handler () { this.errorMessages = {} }
    }
  }
}
</script>
